import {decode as base64_decode, encode as base64_encode} from 'base-64';
import RootStore from './RootStore';
import { postApi,baseURL } from '../components/Utility'
import {
  action,
  computed,
  makeObservable,
  observable,
  autorun,
  runInAction,
} from 'mobx';
import { act } from 'react-dom/test-utils';
import config from "../config";
import { message } from 'antd';


class VehiclePerformanceStore {
  vehiclePerformance=[]
  vehicleTotalPerformanceArray=[]
  totalReport = [];
  total=0;
  rootStore
  loading=false
  pythonReportMessage=false
  pythonReportErrorMessage=false

  constructor(rootStore) {
    makeObservable(this, {
      vehiclePerformance: observable,
      vehicleTotalPerformanceArray: observable,
      total:observable,
      totalReport : observable,
      loadData:action,
      VehicleTotalPerformance:action,
      loading:observable,
      pythonReportMessage:observable,
      pythonReportErrorMessage:observable
    });
     this.rootStore = rootStore;
    
  }


  async loadData({offset,limit,companyId,fromDate,toDate,vehicleId,pageNo}) {
    this.loading=true
    // console.log("vehiclePerformance")
    var postData = {"companyId":companyId,"vehicleId":vehicleId,"fromDate":fromDate,"toDate":toDate,"offset":offset,"limit":limit,"page":pageNo}
   
    if(config.pythonReport === 1){
        
        var response = await postApi.getClient().post("/fleet_report/vehicleperformance", postData);
      
    }else{
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi.getClient().post("index.php?c=vehicle&a=vehiclePerformance", "postData="+base64Input);
        
    }

    this.total = parseInt(response?.data?.data?.TotalCount);
    this.vehiclePerformance = (response?.data?.data?.vehicleperformance)
    this.loading=false;
    
    
  }

  async VehicleTotalPerformance({offset,limit,companyId,fromDate,toDate,vehicleId}) {
    // console.log("vehicletotalPerformance")
    var postData = {"companyId":companyId,"vehicleId":vehicleId,"fromDate":fromDate,"toDate":toDate}
    if(config.pythonReport !== 1){   
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi.getClient().post("index.php?c=vehicle&a=vehicleTotalperformance", "postData="+base64Input);   
        this.loading=false;
    }else{  
         var response = await postApi.getClient().post("/fleet_report/vehicleTotalperformance", postData);
    }
    this.vehicleTotalPerformanceArray = (response?.data?.data)
    this.totalReport = parseInt(response?.data?.data?.TotalCount);
    
  }
  

  async exportExcel(getData) {


    if(config.pythonReport === 1){

      getData = { ...getData, language: "english" }
      
      try {
          var response = await postApi.getClient("report").post("/fleet_report/vehicleperformance/download/excel", getData, {
              responseType: "blob",
          });
      
          const blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
      
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Vehicle Performance Report.xlsx";
      
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
    
      } catch (error) {
          message.error("Failed to download the report. Please try again.")
      }

    }else{
        let lang = "english";
        window.location.href =
          baseURL +
          "index.php?c=vehicle&a=exportvehiclePerformanceExcel&cid=" +
          getData.companyId +
          "&did=" +
          getData.vehicleId +
          // "&int="+
          // getData.interval+
          "&fD=" +
          getData.fromDate +
          "&tD=" +
          getData.toDate +
          "&colList=" +
          getData.colList +
          "&language=" +
          lang;
    }

  }

  async exportpdf(getData) {

    if(config.pythonReport === 1){

      getData = { ...getData, language: "english" }
      
      try {
          var response = await postApi.getClient().post("/fleet_report/vehicleperformance/download/pdf", getData, {
              responseType: "blob",
          });
      
          const blob = new Blob([response.data], {
              type: 'application/pdf'
          });
      
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Vehicle Performane Report.pdf";
      
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
      } catch (error) {
          message.error("Failed to download the report. Please try again.")
      }


    }else{
        let lang = "english";
        window.location.href =
          baseURL +
          "index.php?c=vehicle&a=exportvehiclePerformancePdf&cid=" +
          getData.companyId +
          "&did=" +
          getData.vehicleId +
          // "&int="+
          // getData.interval+
          "&fD=" +
          getData.fromDate +
          "&tD=" +
          getData.toDate +
          "&colList=" +
          getData.colList +
          "&language=" +
          lang;
    }

  }

  async exportcsv(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportvehiclePerformanceCsv&cid=" +
      getData.companyId +
      "&did=" +
      getData.vehicleId +
      // "&int="+
      // getData.interval+
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }
  async exportxml(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportvehiclePerformanceXml&cid=" +
      getData.companyId +
      "&did=" +
      getData.vehicleId +
      // "&int="+
      // getData.interval+
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }
}

export default VehiclePerformanceStore;
